import React, { Component } from 'react'

import { FormattedMessage } from 'react-intl'
import cx from 'classnames'

import { LOCALE_PREFIX } from './constants'

import './style.scss'

export default class VatTooltip extends Component {
    render() {
        return (
            <div>
                <FormattedMessage
                    id={`${LOCALE_PREFIX}.vatTooltipMain`}
                    values={{ strong: (chunks) => <strong>{chunks}</strong>, br: <br /> }}
                />
                <div className={cx('tooltip-vat-icon', 'na')}>
                    <FormattedMessage id={`${LOCALE_PREFIX}.vatNo`} />
                </div>
                <div className={cx('tooltip-vat-icon', 'vat-present')}>
                    <FormattedMessage id={`${LOCALE_PREFIX}.vatActive`} />
                </div>
                <div className={cx('tooltip-vat-icon', 'vat-past')}>
                    <FormattedMessage id={`${LOCALE_PREFIX}.vatHistorical`} />
                </div>
                <div>
                    <FormattedMessage
                        id={`${LOCALE_PREFIX}.vatFooter`}
                        values={{ strong: (chunks) => <strong>{chunks}</strong>, br: <br /> }}
                    />
                </div>
            </div>
        )
    }
}
